import { useEffect } from "react";
import ContactSection from "@/components/sections/ContactSection";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Kontakt | VanAkkeren Räumungsservice";
    return () => { document.title = "VanAkkeren Räumungsservice | Müllheim & Markgräflerland"; };
  }, []);

  return (
    <div className="inner-page contact-page">
      <section className="inner-page-intro">
        <div className="container">
          <span className="eyebrow">VanAkkeren Räumungsservice</span>
          <h1>Direkt mit uns<br /><em>ins Gespräch kommen.</em></h1>
          <p>Müllheim & Umgebung · persönliche Anfrage · individuelle Lösung</p>
        </div>
      </section>
      <ContactSection standalone />
    </div>
  );
}
